/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HTTPPolicySetModule
 */

import { Injector } from '@angular/core';

import {
    HTTP_POLICY_SET_COLLECTION_TOKEN,
} from 'ajs/modules/http-policy-set/http-policy-set.tokens';

import {
    HTTPPolicySetCollection,
    THTTPPolicySetCollection,
} from 'ajs/modules/http-policy-set';

const $injector = '$injector';

export const httpPolicySetCollectionProvider = {
    deps: [$injector],
    provide: HTTPPolicySetCollection,
    useFactory(injector: Injector): THTTPPolicySetCollection {
        return injector.get(HTTP_POLICY_SET_COLLECTION_TOKEN);
    },
};
